/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

import { ExclamationTriangle, Icon, Link, Text, View } from '@az/starc-ui'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
  error?: any
  reset?: () => void
}

export const ErrorPage: FC<Props> = ({ reset }) => {
  const history = useNavigate()

  const handleBack = () => {
    if (reset) {
      reset?.()
      return
    }
    history(-1)
  }

  return (
    <View height="90vh" align="center" justify="center">
      <Icon svg={ExclamationTriangle} size={30} color="600" />
      <View gap={3} align="center" padding={[4, 0]}>
        <Text variant="display-1">Oops...</Text>
        <Text variant="display-5" color="500">
          {"Something's not working here. We'll get it fixed shortly."}
        </Text>
        <Link onClick={handleBack}>
          <Text variant="display-5">Go Back</Text>
        </Link>
      </View>
    </View>
  )
}
